// Sidebar.js
import React, { useState, useEffect, useContext, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTachometerAlt,
  faUsers,
  faUser,
  faWifi,
  faList,
  faCog,
  faBox,
  faFile,
  faMobile,
  faMoneyBill,
  faHandshake,
  faPiggyBank,
  faWarehouse,
  faFileInvoice,
  faRectangleList,
  faFileInvoiceDollar,
  faHands,
  faCreditCard,
} from "@fortawesome/free-solid-svg-icons"; // Import the Font Awesome icons you need
import AuthContext from "../context/AuthContext";
import LanguageContext from "../context/LanguageContext";
import { API_URL } from "../components/api";
import { NavLink } from "react-router-dom";
import axios from "axios";
import "./sidebar.css";
import Wizard from "./wizard";
import Shift from "./shift";
import SiteOrdersNavigation from "./SiteOrdersNavigation";
import Shiftend from "./shiftend";

import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { Accordion, AccordionSummary, AccordionDetails } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import logoImage from "./oss-logo.svg"; // Import your logo image

const Sidebar = ({ isOpen, closeSidebar }) => {
  const { user } = useContext(AuthContext);
  const { direction, t } = useContext(LanguageContext);
  const [data, setData] = useState([]);
  const [accountAccess, setAccountAccess] = useState(false);
  const [collectorAccess, setCollectorAccess] = useState(false);
  const [shift, setShift] = useState("");

  const sidebarRef = useRef(null);
  console.log(data);

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [shiftshow, setShowshift] = useState(false);
  const handleCloseshift = () => setShowshift(false);
  const handleShowshift = () => setShowshift(true);

  const [shiftshowend, setShowshiftend] = useState(false);
  const handleCloseshiftend = () => setShowshiftend(false);
  const handleShowshiftend = () => setShowshiftend(true);
  const handleNavLinkClick = () => {
    // Close the sidebar after 2 seconds
    setTimeout(() => {
      closeSidebar();
    }, 2000);
  };

  const [showWinboxModal, setShowWinboxModal] = useState(false); // State for Winbox modal
  const [username, setUsername] = useState(""); // State for username input
  const [password, setPassword] = useState(""); // State for password input
  const [employees, setEmployees] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState(null);

  // Function to handle opening the Winbox modal
  const handleShowWinboxModal = () => setShowWinboxModal(true);
  const handleCloseWinboxModal = () => setShowWinboxModal(false);

  useEffect(() => {
    const fetchEmployees = async () => {
      try {
        const authTokens = JSON.parse(localStorage.getItem("authTokens"));
        const response = await axios.get(
          `${API_URL}/administration/employees/`,
          {
            headers: {
              Authorization: `Bearer ${authTokens.access}`,
              "Content-Type": "application/json",
            },
            params: {
              username: user.username,
            },
          }
        );

        if (response.status === 200) {
          const formattedEmployees = response.data.map((emp) => ({
            value: emp.employee_id,
            label: `${emp.first_name} ${emp.last_name}`,
          }));
          setEmployees(formattedEmployees);
        }
      } catch (error) {
        console.error("Error fetching employees:", error);
      }
    };

    fetchEmployees();
  }, []);

  const handleAddWinboxUser = async () => {
    try {
      // Ensure authentication tokens exist
      const authTokens = JSON.parse(localStorage.getItem("authTokens"));

      // Validate username format (must be "name.familyname" and lowercase)
      const usernamePattern = /^[a-z]+\.[a-z]+$/;
      const formattedUsername = username.toLowerCase();

      if (!usernamePattern.test(formattedUsername)) {
        alert(
          "Username must be in the format: name.familyname (e.g., bilal.aboubaraki)."
        );
        return;
      }

      // Validate password length (must be at least 8 characters)
      if (password.length < 8) {
        alert("Password must be at least 8 characters long.");
        return;
      }

      // Ensure password contains at least one uppercase letter, one number, and one special character
      const passwordPattern =
        /^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]+$/;

      if (!passwordPattern.test(password)) {
        alert(
          "Password must contain at least one uppercase letter, one number, and one special character."
        );
        return;
      }

      // Check if password is too similar to the username
      const usernameParts = formattedUsername.split(".");
      if (usernameParts.some((part) => password.toLowerCase().includes(part))) {
        alert("Password should not be too similar to the username.");
        return;
      }

      console.log("Adding Winbox User with:", {
        username: user.username,
        user: formattedUsername,
        password: password,
        employee_id: selectedEmployee,
      });

      const response = await axios.post(
        `${API_URL}/radius/winbox/user/`,
        {}, // Empty data body
        {
          headers: {
            Authorization: `Bearer ${authTokens.access}`,
            "Content-Type": "application/json",
          },
          params: {
            username: user.username,
            user: formattedUsername,
            password: password,
            employee_id: selectedEmployee,
          },
        }
      );

      console.log("API Response:", response);

      if (response.status === 200) {
        alert("OSS Winbox user added successfully!");
        setUsername("");
        setPassword("");
        setSelectedEmployee(null);
        handleCloseWinboxModal();
      }
    } catch (error) {
      console.error("Error adding OSS Winbox user:", error);
      alert("Failed to add OSS Winbox user. Please try again.");
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const authTokens = JSON.parse(localStorage.getItem("authTokens"));
        const response = await axios.get(`${API_URL}/administration/groups/`, {
          headers: {
            Authorization: `Bearer ${authTokens.access}`,
          },
          params: {
            username: user.username,
          },
        });

        if (response.status === 200) {
          setData(response.data);
        }
      } catch (error) {
        console.error(error);
      }
    };
    const fetchShift = async () => {
      try {
        const authTokens = JSON.parse(localStorage.getItem("authTokens"));
        const response = await axios.get(`${API_URL}/inventory/shift/status/`, {
          headers: {
            Authorization: `Bearer ${authTokens.access}`,
          },
          params: {
            username: user.username,
          },
        });

        if (response.status === 200) {
          setShift(response.data);
          console.log(response.data);
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchData();
    fetchShift();

    // Add a click event listener to the document to close the sidebar when clicking outside of it
    const handleOutsideClick = (e) => {
      if (
        isOpen &&
        sidebarRef.current &&
        !sidebarRef.current.contains(e.target)
      ) {
        closeSidebar();
      }
    };

    document.addEventListener("click", handleOutsideClick);

    return () => {
      // Remove the event listener when the component unmounts
      document.removeEventListener("click", handleOutsideClick);
    };
  }, [user.username, isOpen, closeSidebar]);


  useEffect(() => {
    let mounted = true;

    const fetchCollectorAccess = async () => {
      try {
        const authTokens = JSON.parse(
          localStorage.getItem("authTokens") ||
            "null"
        );

        if (
          !authTokens ||
          !authTokens.access
        ) {
          if (mounted) {
            setCollectorAccess(false);
          }

          return;
        }

        const response = await axios.get(
          `${API_URL}/accounting/collectors/access/`,
          {
            headers: {
              Authorization:
                `Bearer ${authTokens.access}`,
            },
          }
        );

        if (mounted) {
          setCollectorAccess(
            response.data &&
              response.data.allowed === true
          );
        }
      } catch (error) {
        console.error(
          "Collectors access check failed:",
          error
        );

        if (mounted) {
          setCollectorAccess(false);
        }
      }
    };

    fetchCollectorAccess();

    return () => {
      mounted = false;
    };
  }, [user.username]);

  useEffect(() => {
    let mounted = true;

    const fetchAccountAccess = async () => {
      const authTokens = JSON.parse(
        localStorage.getItem("authTokens") || "null"
      );

      if (!authTokens?.access) {
        if (mounted) {
          setAccountAccess(false);
        }
        return;
      }

      try {
        const response = await axios.get(
          `${API_URL}/accounting/account/access/`,
          {
            headers: {
              Authorization: `Bearer ${authTokens.access}`,
            },
          }
        );

        if (mounted) {
          setAccountAccess(
            response.status === 200
            && response.data.authorized === true
          );
        }
      } catch (error) {
        if (mounted) {
          setAccountAccess(false);
        }
      }
    };

    fetchAccountAccess();

    return () => {
      mounted = false;
    };
  }, [user?.username]);


  return (
    <div className={`sidebar ${isOpen ? "open" : ""}`} ref={sidebarRef} dir={direction}>
      <div className="sidebar-content">
        <img
          src={logoImage}
          alt="Logo"
          className="sidebar-logo"
          style={{ width: "130px", marginLeft: "35px", marginBottom: "30px" }}
        />{" "}
        {/* Set width to 200px */}
        <div className="nav-links">
          <NavLink
            exact
            to="/"
            className="nav-link"
            activeClassName="active"
            onClick={handleNavLinkClick}
          >
            <FontAwesomeIcon
              icon={faTachometerAlt}
              style={{ marginRight: "13px" }}
            />{" "}
            {t("sidebar.dashboard")}
          </NavLink>
          <NavLink
            exact
            to="/clients"
            className="nav-link"
            activeClassName="active"
            onClick={handleNavLinkClick}
          >
            <FontAwesomeIcon icon={faUsers} style={{ marginRight: "10px" }} />{" "}
            {t("sidebar.clients")}
          </NavLink>
          {data === "yes" && (
            <NavLink
              exact
              to="/internet/dealers"
              className="nav-link"
              activeClassName="active"
              onClick={handleNavLinkClick}
            >
              <FontAwesomeIcon icon={faList} style={{ marginRight: "13px" }} />
              {t("sidebar.resellers")}
            </NavLink>
          )}
          {data === "yes" && (
            <NavLink
              exact
              to="/internet/dealers/testing"
              className="nav-link"
              activeClassName="active"
              onClick={handleNavLinkClick}
            >
              <FontAwesomeIcon icon={faList} style={{ marginRight: "13px" }} />
              {t("sidebar.testingResellers")}
            </NavLink>
          )}
          {(data === "yes" || data === "OSS") && (
            <NavLink
              exact
              to="/subscriptions/internet/testing-clients"
              className="nav-link"
              activeClassName="active"
              onClick={handleNavLinkClick}
            >
              <FontAwesomeIcon icon={faList} style={{ marginRight: "13px" }} />
              {t("sidebar.testingClients")}
            </NavLink>
          )}

          {data === "Dealer" && (
            <NavLink
              exact
              to="/plans/resellers"
              className="nav-link"
              activeClassName="active"
              onClick={handleNavLinkClick}
            >
              <FontAwesomeIcon icon={faUser} style={{ marginRight: "10px" }} />{" "}
              {t("sidebar.internetPlans")}
            </NavLink>
          )}

          {(data === "yes" || data === "Reseller") && (
            <NavLink
              exact
              to="/plans/internet"
              className="nav-link"
              activeClassName="active"
              onClick={handleNavLinkClick}
            >
              <FontAwesomeIcon icon={faWifi} style={{ marginRight: "10px" }} />{" "}
              {t("sidebar.internetPlans")}
            </NavLink>
          )}
          {data === "Reseller" && (
            <NavLink
              exact
              to="/resellers"
              className="nav-link"
              activeClassName="active"
              onClick={handleNavLinkClick}
            >
              <FontAwesomeIcon icon={faUser} style={{ marginRight: "10px" }} />{" "}
              {t("sidebar.resellers")}
            </NavLink>
          )}

          {accountAccess && (
            <NavLink
              exact
              to="/account"
              className="nav-link"
              activeClassName="active"
              onClick={handleNavLinkClick}
            >
              <FontAwesomeIcon
                icon={faCreditCard}
                style={{ marginRight: "10px" }}
              />{" "}
              {t("sidebar.account")}
            </NavLink>
          )}

          {(data === "yes" || data === "OSS") && (
            <Accordion>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <FontAwesomeIcon
                  icon={faCreditCard}
                  style={{ marginRight: "13px" }}
                />
                {t("sidebar.subscriptions")}
              </AccordionSummary>
              <AccordionDetails>
                <Accordion>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <FontAwesomeIcon
                      icon={faCreditCard}
                      style={{ marginRight: "13px" }}
                    />
                    {t("sidebar.internet")}
                  </AccordionSummary>
                  <AccordionDetails>
                    <NavLink
                      to="/subscriptions/internet/osss"
                      className="nav-link"
                      activeClassName="active"
                      onClick={handleNavLinkClick}
                    >
                      <FontAwesomeIcon
                        icon={faList}
                        style={{ marginRight: "10px" }}
                      />{" "}
                      {t("sidebar.oss")}
                    </NavLink>
                  </AccordionDetails>
                  <AccordionDetails>
                    <NavLink
                      to="/subscriptions/IDM"
                      className="nav-link"
                      activeClassName="active"
                      onClick={handleNavLinkClick}
                    >
                      <FontAwesomeIcon
                        icon={faList}
                        style={{ marginRight: "10px" }}
                      />{" "}
                      {t("sidebar.idm")}
                    </NavLink>
                  </AccordionDetails>
                </Accordion>
              </AccordionDetails>
              <AccordionDetails>
                <NavLink
                  to="/subscriptions/cable"
                  className="nav-link"
                  activeClassName="active"
                  onClick={handleNavLinkClick}
                >
                  <FontAwesomeIcon
                    icon={faList}
                    style={{ marginRight: "10px" }}
                  />{" "}
                  {t("sidebar.cable")}
                </NavLink>
              </AccordionDetails>
              <AccordionDetails>
                <Accordion>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <FontAwesomeIcon
                      icon={faCreditCard}
                      style={{ marginRight: "13px" }}
                    />
                    {t("sidebar.iptv")}
                  </AccordionSummary>
                  <AccordionDetails>
                    <NavLink
                      to="/subscriptions/IPTV/accounts"
                      className="nav-link"
                      activeClassName="active"
                      onClick={handleNavLinkClick}
                    >
                      <FontAwesomeIcon
                        icon={faList}
                        style={{ marginRight: "10px" }}
                      />{" "}
                      {t("sidebar.accounts")}
                    </NavLink>
                  </AccordionDetails>
                  <AccordionDetails>
                    <NavLink
                      to="/subscriptions/IPTV"
                      className="nav-link"
                      activeClassName="active"
                      onClick={handleNavLinkClick}
                    >
                      <FontAwesomeIcon
                        icon={faList}
                        style={{ marginRight: "10px" }}
                      />{" "}
                      {t("sidebar.subscriptions")}
                    </NavLink>
                  </AccordionDetails>
                </Accordion>
              </AccordionDetails>
            </Accordion>
          )}

          {(data === "yes" || data === "OSS") && (
            <NavLink
              to="/issues/all/"
              className="nav-link"
              activeClassName="active"
              onClick={handleNavLinkClick}
            >
              <FontAwesomeIcon icon={faList} style={{ marginRight: "10px" }} />{" "}
              {t("sidebar.issues")}
            </NavLink>
          )}
          {(data === "yes" || data === "OSS") && (
            <NavLink
              to="/offers/all/"
              className="nav-link"
              activeClassName="active"
              onClick={handleNavLinkClick}
            >
              <FontAwesomeIcon icon={faList} style={{ marginRight: "10px" }} />{" "}
              {t("sidebar.offers")}
            </NavLink>
          )}
          {(data === "yes" || data === "OSS") && (
            <NavLink
              to="/labels"
              className="nav-link"
              activeClassName="active"
              onClick={handleNavLinkClick}
            >
              <FontAwesomeIcon icon={faList} style={{ marginRight: "10px" }} />{" "}
              {t("sidebar.labels")}
            </NavLink>
          )}
          {(data === "yes" || data === "OSS") && (
            <NavLink
              to="/fiber/cores"
              className="nav-link"
              activeClassName="active"
              onClick={handleNavLinkClick}
            >
              <FontAwesomeIcon icon={faList} style={{ marginRight: "10px" }} />{" "}
              {t("sidebar.fiberCores")}
            </NavLink>
          )}
          {(data === "yes" || data === "OSS") && (
            <NavLink
              to="/wireless"
              className="nav-link"
              activeClassName="active"
              onClick={handleNavLinkClick}
            >
              <FontAwesomeIcon icon={faList} style={{ marginRight: "10px" }} />{" "}
              {t("sidebar.wirelessAccessPoints")}
            </NavLink>
          )}
          {(data === "yes" || data === "OSS") && (
            <NavLink
              to="/reporting"
              className="nav-link"
              activeClassName="active"
              onClick={handleNavLinkClick}
            >
              <FontAwesomeIcon icon={faList} style={{ marginRight: "10px" }} />{" "}
              {t("sidebar.reporting")}
            </NavLink>
          )}
          {collectorAccess &&
            data !== "yes" &&
            data !== "OSS" && (
              <Accordion>
                <AccordionSummary
                  expandIcon={
                    <ExpandMoreIcon />
                  }
                >
                  <FontAwesomeIcon
                    icon={faMoneyBill}
                    style={{
                      marginRight: "13px",
                    }}
                  />
                  {t("sidebar.accounting")}
                </AccordionSummary>
                <AccordionDetails>
                  <NavLink
                    exact
                    to="/accounting/collectors"
                    className="nav-link"
                    activeClassName="active"
                    onClick={handleNavLinkClick}
                  >
                    <FontAwesomeIcon
                      icon={faPiggyBank}
                      style={{
                        marginRight: "13px",
                      }}
                    />
                    {t("sidebar.collectors")}
                  </NavLink>
                </AccordionDetails>
              </Accordion>
            )}
          {(data === "yes" || data === "OSS") && (
            <Accordion>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <FontAwesomeIcon
                  icon={faMoneyBill}
                  style={{ marginRight: "13px" }}
                />
                {t("sidebar.accounting")}
              </AccordionSummary>
              <AccordionDetails>
                {shift ? (
                  <button onClick={handleShowshiftend} className="AddClient">
                    <i className="fa fa-user-plus" aria-hidden="true"></i>{" "}
                    {t("sidebar.endShift")}
                  </button>
                ) : (
                  <button onClick={handleShowshift} className="AddClient">
                    <i className="fa fa-user-plus" aria-hidden="true"></i> Start
                    Shift
                  </button>
                )}
              </AccordionDetails>
              <AccordionDetails>
                <NavLink
                  exact
                  to="/accounting/collection"
                  className="nav-link"
                  activeClassName="active"
                  onClick={handleNavLinkClick}
                >
                  <FontAwesomeIcon
                    icon={faPiggyBank}
                    style={{ marginRight: "13px" }}
                  />
                  {t("sidebar.collection")}
                </NavLink>
              </AccordionDetails>
              {data === "yes" && (
                <AccordionDetails>
                  <NavLink
                    exact
                    to="/accounting/collection-requests"
                    className="nav-link"
                    activeClassName="active"
                    onClick={handleNavLinkClick}
                  >
                    <FontAwesomeIcon
                      icon={faMoneyBill}
                      style={{ marginRight: "13px" }}
                    />
                    {t("sidebar.collectionRequests")}
                  </NavLink>
                </AccordionDetails>
              )}
              {collectorAccess && (
                <AccordionDetails>
                  <NavLink
                    exact
                    to="/accounting/collectors"
                    className="nav-link"
                    activeClassName="active"
                    onClick={handleNavLinkClick}
                  >
                    <FontAwesomeIcon
                      icon={faPiggyBank}
                      style={{ marginRight: "13px" }}
                    />
                    {t("sidebar.collectors")}
                  </NavLink>
                </AccordionDetails>
              )}
              <AccordionDetails>
                <NavLink
                  exact
                  to="/accounting/log"
                  className="nav-link"
                  activeClassName="active"
                  onClick={handleNavLinkClick}
                >
                  <FontAwesomeIcon
                    icon={faList}
                    style={{ marginRight: "13px" }}
                  />
                  {t("sidebar.accountingLog")}
                </NavLink>
              </AccordionDetails>
              <AccordionDetails>
                <NavLink
                  exact
                  to="/accounting/payments"
                  className="nav-link"
                  activeClassName="active"
                  onClick={handleNavLinkClick}
                >
                  <FontAwesomeIcon
                    icon={faMoneyBill}
                    style={{ marginRight: "13px" }}
                  />
                  {t("sidebar.payments")}
                </NavLink>
              </AccordionDetails>
              <AccordionDetails>
                <NavLink
                  exact
                  to="/accounting/online-payments"
                  className="nav-link"
                  activeClassName="active"
                  onClick={handleNavLinkClick}
                >
                  <FontAwesomeIcon
                    icon={faMoneyBill}
                    style={{ marginRight: "13px" }}
                  />
                  {t("sidebar.onlinePayments")}
                </NavLink>
              </AccordionDetails>
              <AccordionDetails>
                <Accordion>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <FontAwesomeIcon
                      icon={faCreditCard}
                      style={{ marginRight: "13px" }}
                    />
                    {t("sidebar.orders")}
                  </AccordionSummary>
                  <AccordionDetails>
                    <NavLink
                      exact
                      to="/accounting/order"
                      className="nav-link"
                      activeClassName="active"
                      onClick={handleNavLinkClick}
                    >
                      <FontAwesomeIcon
                        icon={faList}
                        style={{ marginRight: "13px" }}
                      />
                      {t("sidebar.details")}
                    </NavLink>
                  </AccordionDetails>
                  <AccordionDetails>
                    <NavLink
                      exact
                      to="/accounting/order/form"
                      className="nav-link"
                      activeClassName="active"
                      onClick={handleNavLinkClick}
                    >
                      <FontAwesomeIcon
                        icon={faTachometerAlt}
                        style={{ marginRight: "13px" }}
                      />
                      {t("sidebar.addOrder")}
                    </NavLink>
                  </AccordionDetails>
                </Accordion>
                <Accordion>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <FontAwesomeIcon
                      icon={faCreditCard}
                      style={{ marginRight: "13px" }}
                    />
                    {t("sidebar.resellerOrders")}
                  </AccordionSummary>
                  <AccordionDetails>
                    <NavLink
                      exact
                      to="/accounting/order/dealer"
                      className="nav-link"
                      activeClassName="active"
                      onClick={handleNavLinkClick}
                    >
                      <FontAwesomeIcon
                        icon={faList}
                        style={{ marginRight: "13px" }}
                      />
                      {t("sidebar.details")}
                    </NavLink>
                  </AccordionDetails>
                  <AccordionDetails>
                    <NavLink
                      exact
                      to="/accounting/order/form/dealer"
                      className="nav-link"
                      activeClassName="active"
                      onClick={handleNavLinkClick}
                    >
                      <FontAwesomeIcon
                        icon={faTachometerAlt}
                        style={{ marginRight: "13px" }}
                      />
                      {t("sidebar.addOrder")}
                    </NavLink>
                  </AccordionDetails>
                </Accordion>
                <SiteOrdersNavigation
                  onNavigate={handleNavLinkClick}
                />
              </AccordionDetails>{" "}
              <AccordionDetails>
                <NavLink
                  exact
                  to="/accounting/quotation"
                  className="nav-link"
                  activeClassName="active"
                  onClick={handleNavLinkClick}
                >
                  <FontAwesomeIcon
                    icon={faFileInvoice}
                    style={{ marginRight: "13px" }}
                  />
                  {t("sidebar.quotations")}
                </NavLink>
              </AccordionDetails>
              <AccordionDetails>
                <NavLink
                  exact
                  to="/accounting/invoice"
                  className="nav-link"
                  activeClassName="active"
                  onClick={handleNavLinkClick}
                >
                  <FontAwesomeIcon
                    icon={faFileInvoiceDollar}
                    style={{ marginRight: "13px" }}
                  />
                  {t("sidebar.invoices")}
                </NavLink>
                <NavLink
                  exact
                  to="/accounting/invoice/system"
                  className="nav-link"
                  activeClassName="active"
                  onClick={handleNavLinkClick}
                >
                  <FontAwesomeIcon
                    icon={faFileInvoiceDollar}
                    style={{ marginRight: "13px" }}
                  />
                  {t("sidebar.systemInvoices")}
                </NavLink>
              </AccordionDetails>
              <AccordionDetails>
                <Accordion>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <FontAwesomeIcon
                      icon={faCreditCard}
                      style={{ marginRight: "13px" }}
                    />
                    {t("sidebar.reporting")}
                  </AccordionSummary>
                  <AccordionDetails>
                    <NavLink
                      exact
                      to="/accounting/dashboardossss"
                      className="nav-link"
                      activeClassName="active"
                      onClick={handleNavLinkClick}
                    >
                      <FontAwesomeIcon
                        icon={faTachometerAlt}
                        style={{ marginRight: "13px" }}
                      />
                      {t("sidebar.dashboard")}
                    </NavLink>
                  </AccordionDetails>
                  <AccordionDetails>
                    <NavLink
                      exact
                      to="/accounting/drawersos"
                      className="nav-link"
                      activeClassName="active"
                      onClick={handleNavLinkClick}
                    >
                      <FontAwesomeIcon
                        icon={faBox}
                        style={{ marginRight: "13px" }}
                      />
                      Drawers
                    </NavLink>
                  </AccordionDetails>
                  <AccordionDetails>
                    <NavLink
                      exact
                      to="/accounting/receipts"
                      className="nav-link"
                      activeClassName="active"
                      onClick={handleNavLinkClick}
                    >
                      <FontAwesomeIcon
                        icon={faFileInvoice}
                        style={{ marginRight: "13px" }}
                      />
                      {t("sidebar.receipts")}
                    </NavLink>
                  </AccordionDetails>
                  <AccordionDetails>
                    <NavLink
                      exact
                      to="/accounting/shift/receipts"
                      className="nav-link"
                      activeClassName="active"
                      onClick={handleNavLinkClick}
                    >
                      <FontAwesomeIcon
                        icon={faFileInvoice}
                        style={{ marginRight: "13px" }}
                      />
                      {t("sidebar.shiftReceipts")}
                    </NavLink>
                  </AccordionDetails>
                </Accordion>
              </AccordionDetails>
            </Accordion>
          )}

          {(data === "Reseller" || data === "Read") && (
            <Accordion>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <FontAwesomeIcon
                  icon={faCreditCard}
                  style={{ marginRight: "13px" }}
                />
                {t("sidebar.internet")}
              </AccordionSummary>
              <AccordionDetails>
                <NavLink
                  to="/subscriptions/internet/"
                  className="nav-link"
                  activeClassName="active"
                  onClick={handleNavLinkClick}
                >
                  <FontAwesomeIcon
                    icon={faList}
                    style={{ marginRight: "10px" }}
                  />{" "}
                  {t("sidebar.oss")}
                </NavLink>
              </AccordionDetails>
            </Accordion>
          )}
          {data === "Dealer" && (
            <NavLink
              to="/subscriptions/internet/reseller"
              className="nav-link"
              activeClassName="active"
              onClick={handleNavLinkClick}
            >
              <FontAwesomeIcon icon={faList} style={{ marginRight: "13px" }} />{" "}
              {t("sidebar.subscriptions")}
            </NavLink>
          )}
          {data === "Commission" && (
            <NavLink
              to="/subscriptions/internet/osss/commission"
              className="nav-link"
              activeClassName="active"
              onClick={handleNavLinkClick}
            >
              <FontAwesomeIcon icon={faList} style={{ marginRight: "13px" }} />{" "}
              {t("sidebar.subscriptions")}
            </NavLink>
          )}
          {(data === "yes" || data === "OSS") && (
            <NavLink
              to="/subscriptions/internet/osss/services"
              className="nav-link"
              activeClassName="active"
              onClick={handleNavLinkClick}
            >
              <FontAwesomeIcon
                icon={faRectangleList}
                style={{ marginRight: "10px" }}
              />{" "}
              {t("sidebar.subServices")}
            </NavLink>
          )}
          {(data === "yes" || data === "OSS") && (
            <NavLink
              to="/onboarding"
              className="nav-link"
              activeClassName="active"
              onClick={handleNavLinkClick}
            >
              <FontAwesomeIcon icon={faHands} style={{ marginRight: "10px" }} />{" "}
              {t("sidebar.onboarding")}
            </NavLink>
          )}
          {(data === "yes" || data === "OSS") && (
            <NavLink
              to="/inventory"
              className="nav-link"
              activeClassName="active"
              onClick={handleNavLinkClick}
            >
              <FontAwesomeIcon
                icon={faWarehouse}
                style={{ marginRight: "10px" }}
              />{" "}
              {t("sidebar.inventory")}
            </NavLink>
          )}
          {(data === "yes" || data === "OSS") && (
            <NavLink
              to="/mobile"
              className="nav-link"
              activeClassName="active"
              onClick={handleNavLinkClick}
            >
              <FontAwesomeIcon
                icon={faMobile}
                style={{ marginRight: "10px" }}
              />{" "}
              {t("sidebar.mobile")}
            </NavLink>
          )}
          {(data === "yes" || data === "OSS") && (
            <NavLink
              to="/requests"
              className="nav-link"
              activeClassName="active"
              onClick={handleNavLinkClick}
            >
              <FontAwesomeIcon
                icon={faHandshake}
                style={{ marginRight: "10px" }}
              />{" "}
              {t("sidebar.requests")}
            </NavLink>
          )}
          {(data === "yes" || data === "OSS") && (
            <NavLink
              exact
              to="/internet/actions"
              className="nav-link"
              activeClassName="active"
              onClick={handleNavLinkClick}
            >
              <FontAwesomeIcon icon={faUser} style={{ marginRight: "13px" }} />{" "}
              {t("sidebar.actionLog")}
            </NavLink>
          )}

          {(data === "Dealer" || data === "Reseller") && (
            <NavLink
              to="/admin/console"
              className="nav-link"
              activeClassName="active"
              onClick={handleNavLinkClick}
            >
              <FontAwesomeIcon icon={faCog} style={{ marginRight: "10px" }} />{" "}
              {t("sidebar.accounting")}
            </NavLink>
          )}
          {(data === "yes" || data === "OSS") && (
            <button onClick={handleShowWinboxModal} className="AddClient">
              <i className="fa fa-user-plus" aria-hidden="true"></i>{" "}
              {t("sidebar.addOssWinboxUser")}
            </button>
          )}
          {!(user && user.restrict_add) && (
            <button onClick={handleShow} className="AddClient">
              <i className="fa fa-user-plus" aria-hidden="true"></i> Add
            </button>
          )}
        </div>
      </div>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Add</Modal.Title>
        </Modal.Header>
        <Wizard closeModal={handleClose} />
      </Modal>
      <Modal show={shiftshow} onHide={handleCloseshift} centered>
        <Modal.Header closeButton>
          <Modal.Title>Add Shift</Modal.Title>
        </Modal.Header>
        <Shift closeModal={handleCloseshift} />
      </Modal>
      <Modal show={shiftshowend} onHide={handleCloseshiftend} centered>
        <Modal.Header closeButton>
          <Modal.Title>End Shift</Modal.Title>
        </Modal.Header>
        <Shiftend closeModal={handleCloseshiftend} />
      </Modal>
      {/* OSS Winbox User Modal */}
      <Modal show={showWinboxModal} onHide={handleCloseWinboxModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>{t("sidebar.addOssWinboxUser")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group controlId="formEmployee">
              <Form.Label>Employee</Form.Label>
              <Form.Control
                as="select"
                value={selectedEmployee || ""}
                onChange={(e) => setSelectedEmployee(e.target.value)}
              >
                <option value="">Select an employee</option>
                {employees.map((emp) => (
                  <option key={emp.value} value={emp.value}>
                    {emp.label}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>
            <Form.Group controlId="formUsername">
              <Form.Label>Username</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
              />
            </Form.Group>
            <Form.Group controlId="formPassword">
              <Form.Label>Password</Form.Label>
              <Form.Control
                type="password"
                placeholder="Enter password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseWinboxModal}>
            Close
          </Button>
          <Button variant="primary" onClick={handleAddWinboxUser}>
            Add User
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Sidebar;
